import request from "@/utils/request";

export function getHubElements() {
  return request({
    url: `/api/Hub/GetHubElements`,
    method: `get`,
  });
}

export function getHubElementId(id, params) {
  return request({
    url: `/api/Hub/GetHubElement/${id}`,
    method: `get`,
    params,
  });
}

export function postHubElement(data) {
  return request({
    url: `/api/Hub/CreateHubElement`,
    method: `post`,
    data,
  });
}

export function putHubElementId(id, data, params = id) {
  return request({
    url: `/api/Hub/UpdateHubElement/${id}`,
    method: `put`,
    params,
    data,
  });
}

export function deleteHubElement(id, params) {
  return request({
    url: `/api/Hub/DeleteHubElement/${id}`,
    method: "delete",
    params,
  });
}
